import { createAsyncThunk } from "@reduxjs/toolkit";
import AirtableApiClient from "utils/airtableApiClient";
import {
  InvolvedAddressesPayload,
  InvolvedAddressesRecord,
  TransactionData,
  TransactionDataPayload,
} from "./types";

export const getMonthlyDepositDataAction = createAsyncThunk<
  TransactionDataPayload,
  { baseId: string },
  {}
>("monthlyDeposit/get", async ({ baseId }, thunkAPI) => {
  try {
    const client = AirtableApiClient.getInstanceDynamic(baseId);
    const transactionData =
      await AirtableApiClient.fetchAllRecords<TransactionData>(
        client,
        "Transaction Monitoring?view=Master view&filterByFormula=FIND(%22Monthly+Deposit;%22%2C+%7BPage%7D)"
      );
    return { transactionData };
  } catch (err) {
    if (err instanceof Error) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
    return thunkAPI.rejectWithValue({ error: "Unknown error" });
  }
});

export const getMonthlyDepositInvolvedAddressesAction = createAsyncThunk<
  InvolvedAddressesPayload,
  { baseId: string },
  {}
>("monthlyDeposit/getInvolvedAddresses", async ({ baseId }, thunkAPI) => {
  try {
    const client = AirtableApiClient.getInstanceDynamic(baseId);
    const involvedAddressesData =
      await AirtableApiClient.fetchAllRecords<InvolvedAddressesRecord>(
        client,
        "Involved Address?view=Master view&filterByFormula=FIND(%22Monthly+Deposit;%22%2C+%7BPage%7D)"
      );
    return { involvedAddressesData };
  } catch (err) {
    if (err instanceof Error) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
    return thunkAPI.rejectWithValue({ error: "Unknown error" });
  }
});
